"use strict";
"use es6";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.empty = void 0;
var empty = {
  closed: true,
  next: function next(value) {},
  error: function error(err) {
    throw err;
  },
  complete: function complete() {}
};
exports.empty = empty;